export enum ConfigPODTypes {
    GET_CONFIG_POD = '@@configPOD/GET_CONFIG_POD',
    GET_CONFIG_POD_SUCCESS = '@@configPOD/GET_CONFIG_POD_SUCCESS',
    GET_CONFIG_POD_FAIL = '@@configPOD/GET_CONFIG_POD_FAIL',

    SAVE_CONFIG_POD = '@@configPOD/SAVE_CONFIG_POD',
    SAVE_CONFIG_POD_SUCCESS = '@@configPOD/SAVE_CONFIG_POD_SUCCESS',
    SAVE_CONFIG_POD_FAIL = '@@configPOD/SAVE_CONFIG_POD_FAIL',
}
